// 产品分类
<template>
  <div class="detail-wrap">
    <el-form ref="editForm" :model="company">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info" />
          分类信息
        </div>
        <div class="fr">
          <!--          <el-button type="primary" plain class="button-sty" @click="Reload" icon="el-icon-refresh-right">重置-->
          <!--          </el-button>-->
          <el-button type="primary" class="button-sty" icon="el-icon-check"
            v-if="itemCategoryEdit && company.id !== null && company.id !== undefined" @click="upDate">保存
          </el-button>
        </div>
      </div>
      <div class="massing">

        <!-- 左边------- 树型结构 -->
        <div class="detail-wrap left" ref="refLeft">
          <div class="user">
            <basic-container>
              <div class="user__tree">
                <div style="display:flex">
                  <el-input placeholder="关键字过滤" v-model="filterText">
                  </el-input>
                  <el-button class="addBtn" type="primary" size="small" v-if="itemCategorySave" @click="openAddTop"
                    style="margin-left: 10px; line-height: 8px; height: 28px;">添加
                  </el-button>
                </div>

                <Tree ref="tree" :maxLevel="MAX_LEVEL" v-if="isRouterAlive" :show-add="itemCategorySave"
                  :requestData="requestData" @nodeClick="nodeClick" @addNodeHandle="addNodeHandle" />

                <el-dialog style="padding: 40px 20px " :close-on-click-modal="false" :visible.sync="showStarLevelDialog222"
                  width="80%" top="5vh" :show-close="true" :before-close="addHandleClose"
                  :title="addDialogTitle == 'edit' ? '编辑名称' : '新增分类'">
                  <el-form :model="addForm" :rules="addRules" label-width="8vw" ref="addRef">
                    <el-form-item label="名称" prop="name">
                      <el-input size="medium" :maxlength="50" v-model="requestParam.categoryName" placeholder="名称" />
                    </el-form-item>
                    <el-form-item label="编码" prop="code">
                      <el-input size="medium" @blur="inspection(requestParam.categoryCode, null)" :maxlength="10"
                        v-model="requestParam.categoryCode" placeholder="编码" />
                    </el-form-item>
                    <el-form-item label="类型">
                      <el-input size="medium" v-model="categoryType" placeholder="" :readonly="true" />
                      <!--                      <el-select v-model="requestParam.categoryType" :disabled="true"  style="width: 10vw!important;">-->
                      <!--                        <el-option label="产品" :value="1"/>-->
                      <!--                        <el-option label="配件" :value="2"/>-->
                      <!--                        <el-option label="耗材" :value="3"/>-->
                      <!--                      </el-select>-->
                    </el-form-item>

                    <!-- <el-form-item label="购买日期" prop="data">
                      <el-date-picker class="current-date-picker"
                                    v-model="requestParam.data"
                                    type="daterange"
                                    align="right"

                                    style="width: 100%;"
                                    range-separator="-"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                    </el-form-item>
                    <el-form-item label="保修期(按月)" prop="guaranteePeriodMonths">
                      <el-input size="medium" :maxlength="10" type="number" min="0"
                                v-model="requestParam.guaranteePeriodMonths"
                                placeholder="请输入"/>
                    </el-form-item> -->
                    <el-form-item label="保养周期(按月)" prop="serviceIntervalMonths">
                      <el-input size="medium" :maxlength="10" type="number" min="0"
                        v-model="requestParam.serviceIntervalMonths" placeholder="请输入" />
                    </el-form-item>
                    <el-form-item label="识别标识">
                      <el-input size="medium" :maxlength="10" v-model="requestParam.idMark" placeholder="请输入" />
                    </el-form-item>
                    <el-form-item label="完工条码数" prop="barcodeNumber">
                      <el-select v-model="requestParam.barcodeNumber">
                        <el-option :value="1" label="1" />
                        <el-option :value="2" label="2" />
                        <el-option :value="3" label="3" />
                      </el-select>
                      <!--                      <el-input size="medium" :maxlength="10" type="number" min="0" v-model="requestParam.barcodeNumber"-->
                      <!--                                placeholder="请输入"/>-->
                    </el-form-item>
                    <el-form-item label="是否图片质检" prop="picCheckMark">
                      <el-select v-model="requestParam.picCheckMark" style="width: 10vw!important;">
                        <el-option label="否" :value="0" />
                        <el-option label="是" :value="1" />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="是否商城使用" prop="picCheckMark">
                      <el-select v-model="requestParam.saleUse" style="width: 10vw!important;">
                        <el-option label="否" :value="0" />
                        <el-option label="是" :value="1" />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="启用" prop="usable">
                      <el-select v-model="requestParam.usable" style="width: 10vw!important;">
                        <el-option label="禁用" :value="0" />
                        <el-option label="启用" :value="1" />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="排序" prop="">
                      <el-input-number min="0" max="10" style="width: 10vw!important;" :controls="false"
                        v-model="requestParam.seq" />
                    </el-form-item>
                    <el-form-item label="矢量图" prop="">
                      <photo-upload :photo-url.sync="requestParam.pic" style="z-index: 2003;" />
                    </el-form-item>
                  </el-form>
                  <span slot="footer" class="dialog-footer">
                    <el-button size="small" @click="closeAddDialog">取 消</el-button>
                    <el-button size="small" type="primary" @click="addTreeNode">确 定</el-button>
                  </span>
                </el-dialog>
              </div>

            </basic-container>
          </div>
        </div>


        <div class="center"
	ref="refCenter"
	@mousedown.stop.prevent="startResize">⋮</div>
        <!-- 右边------- 基本信息 -->

        <div class="detail-wrap right" ref="refRight" style="    width: calc(100% - 215px);background-color: #fff;">


          <div>

            <!-- 工单信息 -->
            <div class="d-cont edit-mce-box">
              <div class="d-item">
                <div class="title first" style="border-top: 1px solid #ededed;">
                  <b>主信息</b>
                </div>
                <table class="table-detail">
                  <tbody>
                    <tr>
                      <th>
                        <em class="f-red">*</em>
                        分类编码：
                      </th>
                      <td>
                        <el-input type="text" style="width:165px" autocomplete="off" v-model="company.categoryCode"
                          clearable @blur="inspection(company.categoryCode, company.id)" />
                      </td>

                      <th>
                        <em class="f-red">*</em>
                        分类名称：
                      </th>
                      <td>
                        <el-input type="text" style="width:165px" autocomplete="off" v-model="company.categoryName"
                          clearable />
                      </td>
                      <th>
                        <em class="f-red">*</em>
                        类型：
                      </th>
                      <td v-if="company.categoryType == 1">产品</td>
                      <!--                    <td>-->
                      <!-- <el-input type="text" autocomplete="off" style="width:165px" v-model="company.categoryType" :disabled="true" clearable></el-input> -->
                      <!--                      <el-form-item :rules="[{ required: true, trigger: 'blur' }]">-->
                      <!--                        <el-select style="width:165px"  v-model="company.categoryType" >-->
                      <!--                          <el-option label="产品" :value="1" />-->
                      <!--                          <el-option label="配件" :value="2" />-->
                      <!--                          <el-option label="耗材" :value="3" />-->
                      <!--                        </el-select>-->
                      <!--                      </el-form-item>-->
                      <!--                    </td>-->

                    </tr>
                    <div style="height:15px"></div>
                    <tr>
                      <th>
                        上级分类：
                      </th>
                      <td v-if="company.parentName !== null && company.parentName !== undefined">
                        {{ company.parentName }}
                      </td>
                      <td v-else>
                        无
                      </td>

                      <th>
                        <em class="f-red">*</em>
                        完工条码数：
                      </th>
                      <td>
                        <el-select v-model="company.barcodeNumber">
                          <el-option :value="1" label="1" />
                          <el-option :value="2" label="2" />
                          <el-option :value="3" label="3" />
                        </el-select>
                        <!--                      <el-input type="number" min="0" autocomplete="off" v-model="company.barcodeNumber" clearable/>-->
                      </td>
                      <th>
                        <em class="f-red">*</em>
                        启用：
                      </th>
                      <td>
                        <el-form-item :rules="[{ required: true, trigger: 'blur' }]">
                          <el-select style="width:165px" v-model="company.usable">
                            <el-option label="禁用" :value="0" />
                            <el-option label="启用" :value="1" />
                          </el-select>
                        </el-form-item>
                      </td>
                    </tr>


                    <div style="height:15px"></div>

                    <tr>
                      <th>
                        <em class="f-red">*</em>
                        保养周期(按月)：
                      </th>
                      <td>
                        <el-input type="number" min="0" autocomplete="off" v-model="company.serviceIntervalMonths"
                          clearable />
                      </td>
                      <th>
                        <em class="f-red">*</em>
                        是否图片质检：
                      </th>
                      <td>
                        <el-select style="width:165px" v-model="company.picCheckMark">
                          <el-option label="否" :value="0" />
                          <el-option label="是" :value="1" />
                        </el-select>
                      </td>

                      <th>
                        <em class="f-red">*</em>
                        是否商城使用：
                      </th>
                      <td>
                        <el-select style="width:165px" v-model="company.saleUse">
                          <el-option label="否" :value="0" />
                          <el-option label="是" :value="1" />
                        </el-select>
                      </td>



                    </tr>

                    <div style="height:15px"></div>

                    <tr>
                      <th>
                        识别标识：
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="company.idMark" clearable />
                      </td>
                      <th>
                        排序：
                      </th>
                      <td>
                        <el-input-number min="0" max="10" style="width:165px" :controls="false" v-model="company.seq" />
                      </td>
                      <th>矢量图：</th>
                      <td>
                        <!-- <photo-upload :photo-url.sync="company.pic"/> -->
                        <avue-input-icon v-model="company.pic" :icon-list="iconList"></avue-input-icon>

                      </td>
                    </tr>
                    <div style="height:15px"></div>
                    <tr>
                      <th>
                        配件申请展示
                      </th>
                      <td>
                        <el-select style="width:165px" v-model="company.partsApplyShow">
                          <el-option label="否" :value="0" />
                          <el-option label="是" :value="1" />
                        </el-select>
                      </td>
                      <th>
                        <em class="f-red">*</em>
                        是否微信使用:
                      </th>
                      <td>
                        <el-select v-model="company.isShowwx"  >
                          <el-option label="否" :value="0" />
                          <el-option label="是" :value="1" />
                        </el-select>
                      </td>
                      <th>
                        退换货展示
                      </th>
                      <td>
                        <el-select style="width:165px" v-model="company.exchangeShow">
                          <el-option label="否" :value="0" />
                          <el-option label="是" :value="1" />
                        </el-select>
                      </td>
                    </tr>
                    <div style="height:15px"></div>
                    <tr class="pop_time">
                      <th>
                        设计图
                      </th>
                      <td>
                        <div>
                          <photoUpload :photo-url.sync="company.designPic" />
                        </div>
                      </td>
                      <th>
                        首页维修服务标准
                      </th>
                      <td>
                        <div>
                          <photoUpload :photo-url.sync="company.homeUpkeepServiceStandard" />
                        </div>
                      </td>
                      <th>
                        工单维修服务标准
                      </th>
                      <td>
                        <div>
                          <photoUpload :photo-url.sync="company.orderUpkeepServiceStandard" />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <th>
                        首页安装服务标准
                      </th>
                      <td>
                          <div>
                             <photoUpload :photo-url.sync="company.homeInstallServiceStandard" />
                          </div>
                       </td>
                      <th>
                        工单安装服务标准
                      </th>
                      <td>
                        <div>
                          <photoUpload :photo-url.sync="company.orderInstallServiceStandard" />
                        </div>
                      </td>
                      <th>
                        安装须知：
                      </th>
                      <td colspan="2">
                        <el-input type="textarea" :rows="2" placeholder="请输入内容" size="small" v-model="company.installGuide" clearable></el-input>
                      </td>
                     </tr>
                     <tr>
                       <th>
                         分类图：
                       </th>
                       <td>
                         <div>
                           <photoUpload :photo-url.sync="company.iconPic" />
                         </div>
                       </td>
                       <th>常用辅材介绍：</th>
                       <td>
                         <div class="form_picture">
                           <photoUpload :photo-url.sync="company.commonMaterial"/>
                         </div>
                       </td>
                       <th>
                         派单合并大类
                       </th>
                       <td>
                         <el-select v-model="company.paidanHebingDaleiName"
                                    @change="selectHebingDalei" style="width:165px">
                           <el-option v-for="item in paidanHebingDaleiOption" :key="item.id" :label="item.label"
                                      :value="{ value: item.id, label: item.label }" />
                         </el-select>
                       </td>
                      </tr>

                    <div style="height:10px"></div>

                    <tr>
                      <th>
                        创建人：
                      </th>
                      <td>{{ company.createBy }}</td>
                      <th>
                        创建时间：
                      </th>
                      <td>{{ company.createTime }}</td>
                    </tr>

                    <div style="height:15px"></div>
                  </tbody>
                </table>
              </div>
              <!--补充信息< -->
              <div class="d-item">
                <div class="title first" style="border-top: 1px solid #ededed;">
                  <b>保修信息</b>
                  <el-button class="button-sty btn_zdy" type="primary" v-if="itemCategoryEdit && company.id !== null && company.id !== undefined"
                    @click="showStarLevelDialog = true; starLevelObj = null">
                    <i class="el-icon-plus"></i>
                    新增
                  </el-button>
                </div>
                <vxe-table style="width: 95%; margin: 10px auto;"
                 ref="xTable" :column-config="{ resizable: true }" :data="requestParam.guaranteePeriods"
                  :edit-config="{ trigger: 'click', mode: 'cell', showStatus: true }"
                  :header-cell-style="{ background: '#F6FAFF', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080' }"
                  :header-row-style="{ height: '36px' }" :row-config="{ height: 36 }"
                  :row-style="{ fontSize: '12px', background: '#fff' }" :stripe="true" height="150" keep-source
                  show-overflow>
                  <vxe-column field="startDate" title="开始时间" width="110" />
                  <vxe-column field="endDate" title="结束时间" width="110" />
                  <vxe-column field="guaranteePeriodMonthes" title="保修期(按月)" width="110" />

                  <vxe-column field="warrantyPeriod" title="保修年限" width="110" />
                  <vxe-column field="othersDesc" title="其他" width="110" />

                  <vxe-column title="操作" width="50">
                    <template #default="{ row }">
                      <a class="a-link" href="javascript:void(0);" @click="deleteRecalls(row)">
                        <el-tooltip content="删除" effect="dark" placement="top" popper-class="tooltip-skin">
                          <i class="el-icon-delete" />
                        </el-tooltip>
                      </a>
                    </template>
                  </vxe-column>
                </vxe-table>
              </div>

              <!--关键零部件保修< -->
              <div class="d-item">
                <div class="title first" style="border-top: 1px solid #ededed;">
                  <b>关键零部件保修</b>
                  <el-button class="button-sty btn_zdy" type="primary" v-if="itemCategoryEdit && company.id !== null && company.id !== undefined"
                             @click="showKeypartsDialog = true; starKeypartsObj = null">
                    <i class="el-icon-plus"></i>
                    新增
                  </el-button>
                </div>
                <vxe-table style="width: 95%; margin: 10px auto;"
                           ref="xTable" :column-config="{ resizable: true }" :data="requestParam.keypartsPeriodDTOList"
                           :edit-config="{ trigger: 'click', mode: 'cell', showStatus: true }"
                           :header-cell-style="{ background: '#F6FAFF', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080' }"
                           :header-row-style="{ height: '36px' }" :row-config="{ height: 36 }"
                           :row-style="{ fontSize: '12px', background: '#fff' }" :stripe="true" height="150" keep-source
                           show-overflow>
                  <vxe-column field="partsCategoryName" title="配件分类" width="110" />
                  <vxe-column field="startDate" title="开始时间" width="110" />
                  <vxe-column field="endDate" title="结束时间" width="110" />
                  <vxe-column field="guaranteePeriodMonthes" title="保修期(按月)" width="110" />

                  <vxe-column title="操作" width="50">
                    <template #default="{ row }">
                      <a class="a-link" href="javascript:void(0);" @click="deleteKeyparts(row)">
                        <el-tooltip content="删除" effect="dark" placement="top" popper-class="tooltip-skin">
                          <i class="el-icon-delete" />
                        </el-tooltip>
                      </a>
                    </template>
                  </vxe-column>
                </vxe-table>
              </div>

              <!--设计预估费用< -->
              <div class="d-item">
                <div class="title first" style="border-top: 1px solid #ededed;">
                  <b>设计预估费用</b>
                  <el-button class="button-sty btn_zdy" type="primary" v-if="itemCategoryEdit && company.id !== null && company.id !== undefined"
                             @click="showStarFeeDialog = true; starFeeObj = null">
                    <i class="el-icon-plus"></i>
                    新增
                  </el-button>
                </div>
                <vxe-table style="width: 95%; margin: 10px auto;"
                           ref="xTable" :column-config="{ resizable: true }" :data="requestParam.designFeeDTOS"
                           :edit-config="{ trigger: 'click', mode: 'cell', showStatus: true }"
                           :header-cell-style="{ background: '#F6FAFF', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080' }"
                           :header-row-style="{ height: '36px' }" :row-config="{ height: 36 }"
                           :row-style="{ fontSize: '12px', background: '#fff' }" :stripe="true" height="150" keep-source
                           show-overflow>
                  <vxe-column field="seq" title="序号" width="110" />
                  <vxe-column field="feeName" title="费用名称" width="110" />
                  <vxe-column title="操作" width="50">
                    <template #default="{ row }">
                      <a class="a-link" href="javascript:void(0);" @click="deleteRecallsFee(row)">
                        <el-tooltip content="删除" effect="dark" placement="top" popper-class="tooltip-skin">
                          <i class="el-icon-delete" />
                        </el-tooltip>
                      </a>
                    </template>
                  </vxe-column>
                </vxe-table>
              </div>


              <!--设计勘测< -->
              <div class="d-item">
                <div class="title first" style="border-top: 1px solid #ededed;">
                  <b>设计勘测</b>
                  <el-button class="button-sty btn_zdy" type="primary" v-if="itemCategoryEdit && company.id !== null && company.id !== undefined"
                             @click="showStarSurveyDialog = true; starSurveyObj = null">
                    <i class="el-icon-plus"></i>
                    新增
                  </el-button>
                </div>
                <vxe-table style="width: 95%; margin: 10px auto;"
                           ref="xTable" :column-config="{ resizable: true }" :data="requestParam.designSurveyDTOS"
                           :edit-config="{ trigger: 'click', mode: 'cell', showStatus: true }"
                           :header-cell-style="{ background: '#F6FAFF', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080' }"
                           :header-row-style="{ height: '36px' }" :row-config="{ height: 36 }"
                           :row-style="{ fontSize: '12px', background: '#fff' }" :stripe="true" height="150" keep-source
                           show-overflow>
                  <vxe-column field="seq" title="序号" width="110" />
                  <vxe-column field="surveyName" title="项目名称" width="110" />

                  <vxe-column title="操作" width="50">
                    <template #default="{ row }">
                      <a class="a-link" href="javascript:void(0);" @click="deleteRecallsSurvey(row)">
                        <el-tooltip content="删除" effect="dark" placement="top" popper-class="tooltip-skin">
                          <i class="el-icon-delete" />
                        </el-tooltip>
                      </a>
                    </template>
                  </vxe-column>
                </vxe-table>
              </div>
            </div>


          </div>

        </div>


        <!-- 以上右边 -->

      </div>
    </el-form>
       <!-- 添加信息 -->
       <addProductDialog v-if="showStarLevelDialog2" :parentId="this.requestParam.parentId" :visiable.sync="showStarLevelDialog2" multi="true"
      @commitDataIndex="saveDataIndex" />
          <!-- 添加时间 -->
    <starLevel v-if="showStarLevelDialog" :starLevelObj="starLevelObj" :visiable.sync="showStarLevelDialog" multi="true"
      @commitData="commitStarLevelData" />

    <designFee v-if="showStarFeeDialog" :starFeeObj="starFeeObj" :visiable.sync="showStarFeeDialog" multi="true"
               @commitData="commitStarLevelDataFee" />

    <designSurvey v-if="showStarSurveyDialog" :starSurveyObj="starSurveyObj" :visiable.sync="showStarSurveyDialog" multi="true"
               @commitData="commitStarLevelDataSurvey" />
    <!--关键零部件保修期-->
    <keypartsDialog v-if="showKeypartsDialog" :starKeypartsObj="starKeypartsObj" :visiable.sync="showKeypartsDialog" multi="true"
                  @commitData="commitKeypartsData" />
  </div>
</template>

<script>
import {
  fetchTree,
  getObj
} from "@/api/admin/type_tree";
import {
  mapGetters
} from "vuex";
import ExcelUpload from "@/components/upload/excel";
import Tree from '@/components/tree/index'
import api from "@/api/projectApi";
import PhotoUpload from "./itemCatPhotoUpload.vue";
import iconList from '@/const/iconListSvg'
// 添加产品
import addProductDialog from './addProductDialog.vue';
// 星级
import starLevel from './starLevel.vue';
import designFee from './designFee.vue';
import designSurvey from './designSurvey.vue';
import keypartsDialog from './keypartsDialog.vue';
import {loadDictData} from "@/config/dictType";

export default {
  // inject: ['reload'],
  name: "productType",
  components: {
    starLevel,
    designFee,
    designSurvey,
    addProductDialog,
    PhotoUpload,
    ExcelUpload, Tree,keypartsDialog
  },
  data() {
    return {
      showStarLevelDialog2: false,
      showStarLevelDialog: false,
      showStarFeeDialog:false,
      showStarSurveyDialog:false,
      showKeypartsDialog:false,

      iconList: iconList,

      itemCategorySave: false,
      itemCategoryEdit: false,
      disabledCategoryType: false,
      isRouterAlive: true,
      is_new: false,
      // 以上大小ID  类型信息
      filterText: '',
      addType: 1,
      addNode: '',
      _node_level: '',
      NODE_KEY: "id", // id对应字段
      MAX_LEVEL: 2, // 设定最大层级
      NODE_ID_START: 0, // 新增节点id，逐次递减
      startId: null,
      paidanHebingDaleiOption:[],//合并大类下拉框
      defaultProps: {
        // 默认设置
        children: "children",
        label: "label",
        id: "id",
        isLeaf: "leaf"
      },
      addDataList: "",
      addForm: {
        name: "",
        code: ""
      },
      addRules: {
        name: [{
          required: true,
          message: "请输入名称",
          trigger: "blur"
        }],
        code: [{
          required: true,
          message: "请输入编码",
          trigger: "blur"
        }],
        barcodeNumber: [{ required: true }],
        guaranteePeriodMonths: [{ required: true }],
        serviceIntervalMonths: [{ required: true }],
        picCheckMark: [{ required: true }],
        usable: [{ required: true }],
      },
      addDialogTitle: "new",
      company: {
        companyId: "",
        categoryName: '',
        categoryCode: "",
        parentId: "",
        categoryType: 1,
        barcodeNumber: 1,
        guaranteePeriodMonths: 0,
        serviceIntervalMonths: 0,
        idMark: null,
        picCheckMark: 0,
        saleUse: 0,
        isShowwx:0,
        data: null,
        usable: 1,
        seq: 0,
        pic: null,
        iconPic: null,
        partsApplyShow: 0,
        guaranteePeriods: [],
        designFeeDTOS:[],
        designSurveyDTOS:[],
        keypartsPeriodDTOList:[]
      },
      searchForm: {},
      tree: {
        categoryName: '',
        categoryCode: "",
        parentId: "",
        categoryType: 1,
        picCheckMark: 0,
        usable: 1
      },
      list: [],
      listLoading: true,
      form: {},
      rolesOptions: [],
      postOptions: [],
      excelUpload: false,
      temp: {
        resolve: '',
        leaf: false
      },
      requestParam: {
        starLevelId: 0,
        companyId: "",
        categoryName: '',
        categoryCode: "",
        parentId: "",
        categoryType: 1,
        barcodeNumber: 1,
        guaranteePeriodMonths: 0,
        serviceIntervalMonths: 0,
        idMark: null,
        usable: 1,
        picCheckMark: 0,
        saleUse: 0,
        isShowwx:0,
        seq: 0,
        pic: null,
        data: [],
        startDate: null,
        endDate: null,
        guaranteePeriods: [],
        designFeeDTOS: [],
        designSurveyDTOS: [],
        keypartsPeriodDTOList:[],
      },
      categoryType: '产品'
    };
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  created() {
    this.itemCategorySave = this.permissions['item_category_add']
    this.itemCategoryEdit = this.permissions['item_category_edit']
  },
  mounted() {
    this.loadHebingDaleiData()
  },
  methods: {
    // 加载数据字典中产品分类合并大类
    loadHebingDaleiData() {
      loadDictData("产品分类合并大类").then(res => {
        this.paidanHebingDaleiOption = []
        res.data.data.forEach(item => {
          this.paidanHebingDaleiOption.push({
            label: item.label,
            id: item.id
          })
        })
      })
    },
    //获取产品分类合并大类名称
    selectHebingDalei(data) {
      this.company.paidanHebingDaleiId = data.value;
      this.company.paidanHebingDaleiName = data.label;
    },
    // 左右拖动这里的一个大概说明，就是把减少的div宽度，加到另一个div的宽度上去，就是现实一增一减；变量自己取data定义就行了，
    startResize(event) {
      this.startX = event.clientX;
      this.startWidth = this.$refs.refRight.offsetWidth;
      console.log(event.clientX,this.startWidth,'this.startWidth')
      this.isResizing = true;

      window.addEventListener('mousemove', this.doResize);
      window.addEventListener('mouseup', this.stopResize);
    },
    doResize(event) {
      if (this.isResizing) {console.log(event.clientX,'this.startWidth')
        const deltaX = -event.clientX + this.startX;
        this.$refs.refRight.style.width = this.startWidth + deltaX + 'px';
      }
    },
    stopResize() {
      this.isResizing = false;
      window.removeEventListener('mousemove', this.doResize);
      window.removeEventListener('mouseup', this.stopResize);
    },

    deleteRecalls(row){
      this.$baseConfirm('您确定要删除吗？').then(() => {
        console.log(row, 'deleteRecalls')
        this.requestParam.guaranteePeriods = this.requestParam.guaranteePeriods.filter(item => item.guaranteePeriodMonthes !== row.guaranteePeriodMonthes)
      })
    },

    deleteRecallsFee(row){
      this.$baseConfirm('您确定要删除吗？').then(() => {
        console.log(row, 'deleteRecalls')
        this.requestParam.designFeeDTOS = this.requestParam.designFeeDTOS.filter(item => item.feeName !== row.feeName)
      })
    },

    deleteRecallsSurvey(row){
      this.$baseConfirm('您确定要删除吗？').then(() => {
        console.log(row, 'deleteRecalls')
        this.requestParam.designSurveyDTOS = this.requestParam.designSurveyDTOS.filter(item => item.surveyName !== row.surveyName)
      })
    },
    deleteKeyparts(row){
      this.$baseConfirm('您确定要删除吗？').then(() => {
        console.log(row, 'deleteKeyparts')
        this.requestParam.keypartsPeriodDTOList = this.requestParam.keypartsPeriodDTOList.filter(item => item.partsCategoryId !== row.partsCategoryId)
      })
    },

    commitStarLevelData(data) {
      console.log("guaranteePeriodsdata", data)
      let filter = this.requestParam.guaranteePeriods.filter(item => item.starLevelId !== data.starLevelId)
      filter.push(data)
      this.requestParam.guaranteePeriods = filter;
      console.log("this.requestParam.snSiteStarLevelDTOS时间", this.requestParam.guaranteePeriods)
    },

    inspection(code, id) {
      this.$http.post(api.basItemCategory.inspectionUrl, { value: code, id: id }).then(res => {
        if (!res.data.data) {
          this.$message.error("编码已存在，请重新输入")
          if (this.showStarLevelDialog2) {
            this.requestParam.categoryCode = null
          } else
            this.company.categoryCode = null
        }
      })
    },

    commitStarLevelDataFee(data) {
      console.log("guaranteePeriodsdata", data)
      let filter = this.requestParam.designFeeDTOS.filter(item => item.feeName !== data.feeName)
      filter.push(data)
      this.requestParam.designFeeDTOS = filter;
    },

    commitStarLevelDataSurvey(data) {
      console.log("guaranteePeriodsdata", data)
      let filter = this.requestParam.designSurveyDTOS.filter(item => item.surveyName !== data.surveyName)
      filter.push(data)
      this.requestParam.designSurveyDTOS = filter;
    },

    commitKeypartsData(data){
      console.log("keypartsPeriodsdata", data)
      let filter = this.requestParam.keypartsPeriodDTOList.filter(item => item.partsCategoryId !== data.partsCategoryId)
      filter.push(data)
      this.requestParam.keypartsPeriodDTOList = filter;
    },

    requestData(parentId, resolve, leaf) {  // 树形控件数据请求
      this.$http({
        url: api.basItemCategory.getListUrl,
        method: 'post',
        data: { parentId: parentId, categoryType: 1 }
      }).then(res => {
        let array = []
        res.data.data.forEach(item => {
          let obj = {}
          obj.dataId = item.id
          obj.name = item.categoryName
          obj.barcodeNumber = item.barcodeNumber
          obj.guaranteePeriodMonths = item.guaranteePeriodMonths
          obj.serviceIntervalMonths = item.serviceIntervalMonths
          obj.idMark = item.idMark
          obj.categoryType = item.categoryType
          obj.leaf = !item.hasChild
          array.push(obj)
        })
        resolve(array)
      })
    },
    nodeClick(id) {  // 节点点击回显
      this.$http({
        url: '/basic/basItemCategory/get',
        method: 'post',
        data: { id: id }
      }).then(res => {
        this.disabledCategoryType = res.data.data.parentId !== null;
        this.requestParam.categoryType = res.data.data.categoryType
        this.company = res.data.data
        this.requestParam.guaranteePeriods = res.data.data.guaranteePeriods
        this.requestParam.designFeeDTOS = res.data.data.designFeeDTOS
        this.requestParam.designSurveyDTOS = res.data.data.designSurveyDTOS
        this.requestParam.keypartsPeriodDTOList = res.data.data.keypartsPeriodDTOList
      })
    },
    addNodeHandle(resolve, leaf, parentId, categoryType) {
      this.showStarLevelDialog2 = true
      this.requestParam.parentId = parentId
      this.requestParam.categoryType = 1
      this.temp.resolve = resolve
      this.temp.leaf = leaf
    },

    saveDataIndex() {
      this.$mask.open()
this.requestData()
       this.$mask.close()
    },

    closeAddDialog() {
      this.showStarLevelDialog2 = false
      this.requestParam.categoryCode = ''
      this.requestParam.categoryName = ''
      this.requestParam.categoryType = '1'
      this.requestParam.barcodeNumber = '1'
      this.requestParam.guaranteePeriodMonths = '0'
      this.requestParam.serviceIntervalMonths = '0'
      this.requestParam.idMark = ''
      this.requestParam.picCheckMark = 0
      this.requestParam.usable = 1
      this.requestParam.pic = null
      this.requestParam.seq = 0
    },
    addHandleClose() {
      this.showStarLevelDialog2 = false;
      this.$refs.addRef.resetFields();
    },


    // 点击确定 新增子级菜单
    // addData() {
    //   this.addTreeNode();
    // var t = this;
    // this.$refs.addRef.validate(async (valid) => {
    //   if (valid) {
    //     if (t.addType == 1) {
    //       t.handleAddTop();
    //       this.showStarLevelDialog2 = false;
    //     } else if (t.addType == 2) {
    //       const obj = JSON.parse(JSON.stringify(t.addForm));
    //       obj[this.NODE_KEY] = ++this.startId;
    //       obj.id=Number(obj[this.NODE_KEY]);
    //       console.log(obj, "子级obj")
    //       t.handleAdd(t.addNode, t.addDataList, obj.coed,obj[this.NODE_KEY])
    //       this.showStarLevelDialog2 = false;
    //     }
    //   } else {
    //     console.log("error submit!!");
    //     return false;
    //   }
    // });
    // },
    // 新增顶级结点
    openAddTop() {
      this.showStarLevelDialog2 = true;
      this.addDialogTitle = "new";
      this.requestParam.parentId = ''
    },
    // 新增子级节点打开事件
    appendChild(node, data) {
      this.addType = 2;
      this.addForm.name = "";
      this.addForm.code = "";
      this.showStarLevelDialog2 = true;
      this.addDialogTitle = "new";
      this.addDataList = data;
      this.addNode = node

    },


    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },

    upDate() {
      this.company.guaranteePeriods = this.requestParam.guaranteePeriods
      this.company.designFeeDTOS = this.requestParam.designFeeDTOS
      this.company.designSurveyDTOS = this.requestParam.designSurveyDTOS
      this.company.keypartsPeriodDTOList = this.requestParam.keypartsPeriodDTOList
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$baseConfirm('您确定要保存吗？').then(() => {
            var url = '/basic/basItemCategory/update';
            let formData = this.company;
            console.log(formData, 'formData的值')
            this.$http({
              url: url,
              method: `post`,
              data: formData,
            }).then(() => {
              this.$message.success("保存成功！");
              this.reload()
            }).catch(e => {
              console.error(e)
              this.$message.error("保存失败！");
            })
          });
        }
      });

    },

    saveData(_data, obj, _node) {
      var url = '/basic/basItemCategory/save';
      let formData = this.company;

      console.log(formData, 'formData的值')
      this.$http({
        url: url,
        method: `post`,
        data: formData,
        isLoading: true,
      }).then(res => {
        obj.id = res.data.data
        // 判断字段是否存在
        if (!_data.children) {
          this.$set(_data, "children", []);
        }
        // 新增数据
        _data.children.push(obj);
        // 展开节点
        if (!_node.expanded) {
          _node.expanded = true;
        }
      });
      // this.reload()
    },

    init(_node, _data, _name) {
      // fetchTree(this.tree).then(response => {
      //   let treeData = response.data.data;
      //   console.log(response.data.data, "response.data.data值");
      // this.treeData = treeData.map(item => ({
      //   label: item.categoryName,
      //   id: item.id,
      //   leaf:Number(item.isChild)==1?false:true,
      //   categoryCode: item.categoryCode
      // }))
      //   console.log(this.treeData, "this.treeData值");


      // });
    },
    loadChildNode(node, resolve) {
      console.log(node, "loadChildNode.node")
      const spaceParentGuid = {
        parentId: node.data.id
      }
      fetchTree(spaceParentGuid).then(({
        data
      }) => {
        console.log(data, "data.data的值"),
          resolve(
            data.data.map(item => {
              return {
                label: item.categoryName,
                id: item.id,

                leaf: Number(item.isChild) == 1 ? false : true,
              }
            })
          )
      });
      // this.treeData=data.data


    },
    // // 重置
    // Reload() {
    //   this.company = []
    // },
    handleNodeClick(data) {
      let id = { id: data.id };
      // this.treeID = data.id;
      console.log(id, "点击id的值");
      // this.company.id = Number(id);
      getObj(id).then(response => {
        this.company = response.data.data;
        console.log(response.data.data, "response.data.data值");
        console.log(this.company, "this.treeData值");
      }).catch(err => {
        err
      })
    },
    exportExcel() {
      this.downBlobFile("/admin/user/export", this.searchForm, "user.xlsx");
    },

  },
  watch: {
    filterText(val) {
      console.log(val)
      this.$refs.tree.filterRef(val);
    }
  },
};

</script>

<style lang="scss" scoped>
.is_new {
  display: none
}

.d-item {
  border-left: 1px solid #ededed;
}

.el-main {
  display: inline-block;
  height: 791.18px;
}

::v-deep .el-card__body,
.el-main {
  padding: 20px 8px;
}

.basic-container {
  padding: 0px 0px 8px 0px !important;
}

.table-detail {
  padding-left: 35px;
  display: inline-block;

  tr th {
    font-weight: 400;
    text-align: right;
    width: 9vw;
    font-size: 12px;
    position: relative;
    padding: 0 10px 0 4px;
    color: rgba(86, 86, 86, 0.96);


  }
}

tr td {
  font-weight: 400;
  text-align: left;
  width: 112px;
  font-size: 12px;
  position: relative;
  padding: 0 10px 0 4px;
  color: rgba(86, 86, 86, 0.96);
}

.pop_time {
  td {
    font-weight: 400;
    text-align: left;
    width: 112px;
    font-size: 12px;
    position: relative;
    padding: 0 10px 0 4px;
    color: rgba(86, 86, 86, 0.96);
  }
}

.title b {
  display: inline-block;
  line-height: 28px;
  font-size: 16px;
  font-weight: 600;
  margin-right: 84px;
  vertical-align: middle;
  color: #00c4b3;
  position: relative;
  z-index: 2;
  background: rgba(0, 196, 179, 0.16);
  margin-left: 0px;
  margin-top: 8px;
  padding-left: 12px;
  padding-right: 14px;
  border-radius: 0 28px 28px 0;
}

.massing {
  display: flex;
  height: calc(100vh - 94px);
  .left {
      flex: 1;
      height: 100%;
      min-width: 250px;
      width:600px
    }
    .center {
      cursor: col-resize;//拖动鼠标样式
      height: 100%;
      width: 8px;

      cursor: col-resize;
  // position: relative;
  // top: 45%;
  background-color: #d6d6d6;
  border-radius: 5px;
  margin-top: 150px;
  margin-right: 5px;
  width: 10px;
  height: 50px;
  background-size: cover;
  background-position: center;
  font-size: 32px;
  color: white;
    }
    .right {
      width: calc(100% - 600px);
      min-width: calc(100% - 600px);
      height: 100%;
    }
}

.detail-wrap .d-header {
  border-bottom: solid 1px #E9E9E9;
  height: 34px;
  line-height: 34px;
  margin: 7px 0px 6px 12px;
  padding: 0px 24px 0 14px;
  font-size: 13px;
  overflow: hidden;
  background-color: #FFF;
}

.detail-wrap .d-header .fl>i {
  color: #00c4b3;
  display: inline-block;
  vertical-align: middle;
  margin-right: 6px;
  margin-bottom: 1px;
  font-size: 14px;
  font-size: 14px;
}

.d-cont {
  border-bottom: 1px solid #ededed;
  padding-top: 10px;

}

::v-deep .el-card__body,
.el-main {
  padding: 6px 8px;
  border: 1px solid #ededed;
  margin-top: 10px;
  margin-left: 12px;
  margin-right: 5px;
}

.user {
  // height: 802.18px;
  background-color: #fff;
  margin-left: 12px;

  &__tree {
    // padding: 15px;
    // border: 1px solid #ededed;
    // width: 192px;
    border: 1px solid #ededed;
    border-top: none;
    max-height: 70vh;
    overflow: hidden;
    overflow-y: scroll;
  }

  &__main {
    .el-card__body {
      padding-top: 0;
    }
  }
}

// 装图片的  大框
//::v-deep.table-detail .el-upload--picture-card {
//  margin-top: 10px;
//  width: 80px;
//  height: 40px;
//  line-height: 45px !important;
//}


.basic-container .el-card {
  width: 100%;
  height: 800px;
}


.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

::v-deep.el-tree {
  width: calc(100% - 32px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  color: rgba(86, 86, 86, 0.96);
}


// 重新修改tree组件样式
.tree_icon {
  background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
  .el-tree-node {
    position: relative;
    padding-left: 0px;
  }

  .el-tree-node__content {
    margin-top: 0px;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node::before {
    content: '';
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #d9d9d9;
  }

  .el-tree-node:last-child::before {
    height: 38px;
  }

  .el-tree-node::after {
    content: '';
    width: 24px;
    height: 1px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #d9d9d9;
  }

  &>.el-tree-node::after {
    border-top: none;
  }

  &>.el-tree-node::before {
    border-left: none;
  }

  .el-tree-node__expand-icon {
    font-size: 17px;

    // color: #000;
    &.is-leaf {
      color: transparent;
      // display: none;
    }
  }
}

::v-deep .el-range-editor--medium.el-input__inner {
  height: 30px !important;
}
::v-deep .el-form-item {
    margin-bottom: 0;
    display: inline-block;
}
</style>
